import { render, staticRenderFns } from "./SiInputRadio.vue?vue&type=template&id=635684db&lang=html&"
import script from "./SiInputRadio.vue?vue&type=script&lang=js&"
export * from "./SiInputRadio.vue?vue&type=script&lang=js&"
import style0 from "./SiInputRadio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VLabel,VRadio,VRadioGroup})
